import { faEdit, faTrash } from '@fortawesome/pro-regular-svg-icons';
import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { Button } from 'src/components/Button';
import { Icon } from 'src/components/Icon';
import { IconButton } from 'src/components/IconButton';
import { TextField } from 'src/components/TextField';

import { FilterTypeComponentProps } from './types';

export const FilterTypePurchase: FC<FilterTypeComponentProps> = ({
  value,
  onChange,
  onDelete,
}) => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'reminderFilters.filterSet',
  });

  const [editing, setEditing] = useState(false);

  const handleToggle = () => setEditing((e) => !e);

  return (
    <Box display="flex" alignItems="center" gap={1} flexWrap="wrap">
      {editing ? (
        <>
          <TextField
            size="medium"
            value={value.negate ? 'not' : 'is'}
            onChange={(e) =>
              onChange({ ...value, negate: e.target.value === 'not' })
            }
            options={[
              { value: 'is', label: t('havePurchased') },
              { value: 'not', label: t('haveNotPurchased') },
            ]}
            sx={{ minWidth: 100 }}
          />
          {t('anything')}
          <Button color="primary" variant="prominent" onClick={handleToggle}>
            {t('done')}
          </Button>
        </>
      ) : (
        <>
          {value.negate ? t('notPurchasedAnything') : t('purchasedSomething')}
          <IconButton size="small" color="primary" onClick={handleToggle}>
            <Icon icon={faEdit} size="small" />
          </IconButton>
          <IconButton size="small" color="error" onClick={() => onDelete()}>
            <Icon icon={faTrash} size="small" />
          </IconButton>
        </>
      )}
    </Box>
  );
};
